// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2FYBC","label":"Category_label__2WjpB","content":"Category_content__IM_vS","header":"Category_header__261B_","location":"Category_location__L0qCo"};